/** Query param used by View Notices and Drive to pre-select a subcircle filter. */
export const CIRCLE_FILTER_PARAM = "circle";

export function viewNoticesHref(circleId: string): string {
  return `/view-notices?${CIRCLE_FILTER_PARAM}=${encodeURIComponent(circleId)}`;
}

export function driveHref(circleId: string): string {
  return `/drive?${CIRCLE_FILTER_PARAM}=${encodeURIComponent(circleId)}`;
}

export function parseCircleFilterParam(
  searchParams: URLSearchParams
): string | null {
  const value = searchParams.get(CIRCLE_FILTER_PARAM)?.trim();
  return value || null;
}
